import { useQueryRequirementDefinitionsSettings } from "./useQueryRequirementDefinitionsSettings";

type MultiParams = Parameters<typeof useQueryRequirementDefinitionsSettings>[0];

type Params = Omit<MultiParams, "requirementDefinitions"> & {
  requirementDefinition: MultiParams["requirementDefinitions"][0];
};

export const useQueryRequirementDefinitionsSetting = (params: Params) => {
  const requirementDefinitionsSettings = useQueryRequirementDefinitionsSettings(
    {
      ...params,
      requirementDefinitions: [params.requirementDefinition]
    }
  );

  const data = params.requirementDefinition.dataSourceId
    ? requirementDefinitionsSettings.data?.[
        params.requirementDefinition.dataSourceId
      ]
    : undefined;

  return {
    ...requirementDefinitionsSettings,
    data
  };
};
